import './lib/debug';
import MggpEPG from './MggpEPG';
import resolveVersion from './lib/resolveVersion';

window.MggpEPG = MggpEPG;

const version = resolveVersion(document);

load(version);

if (process.env.NODE_ENV === 'production') {
  /* eslint-disable no-console */
  console.log(`Build date: ${new Date(process.env.REACT_APP_BUILD_DATE)}`);
  /* eslint-disable no-console */
}

function load(version) {
  window.debug()('%s mode enabled', version);

  /*
      /!* webpackMode: "eager" *!/
      /!* webpackPreload: true *!/
  */

  return import(
    /* webpackChunkName: "[request]" */
    `./${version}/index.js` );
}

